import {
  SAVE_INFORMATION,
  SAVE_INFORMATION_SUCCESS,
  SAVE_INFORMATION_FAILURE
} from './actionTypes';

const initialState = {
  isSaving: false,
  information: {},
  error: []
};

export const newInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_INFORMATION:
      return { ...state, isSaving: true };
    case SAVE_INFORMATION_SUCCESS:
      return { ...state, isSaving: false, information: action.payload };
    case SAVE_INFORMATION_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isSaving = state => state.newInformation.isSaving;
export const getInformation = state => state.newInformation.information;
export const getError = state => state.newInformation.error;



// WEBPACK FOOTER //
// ./src/modules/InformationForm/reducer.js